import { translations } from "./translations";

export {
  translations,
}



// WEBPACK FOOTER //
// ./locales/vi_VN/index.js